<app-router-link
  [fragment]="fragment()"
  [route]="route()">
  <div class="hover:text-primary">{{ text() }}</div>
</app-router-link>
